import React from 'react'

const deployData = [
  {
    heading: 'Industry Relevance',
    para: 'Curriculum designed to meet the specific needs and requirements of the industry, ensuring graduates are well-prepared for their roles.',
  },
  {
    heading: 'Enhanced Productivity',
    para: 'Graduates enter the workforce with the skills to contribute effectively, driving productivity and innovation within organizations.',
  },
  {
    heading: 'Improved Employability',
    para: 'Highly sought-after skills and knowledge increase graduates’ employability, leading to better job opportunities and career prospects.',
  },
]

const ReadyToDeploy = () => {
  return (
    <section className='home_section'>
      <span className='home_eyebrow'>Outcomes</span>
      <h2 className='home_heading'>Ready-to-deploy knowledge that lifts industry productivity and graduate employability</h2>
      <p className='home_lead'>Education should be a catalyst for positive change in the industry. Our programs empower graduates to make an immediate impact in their roles, contributing to the growth and success of their organizations.</p>

      <div className='bento'>
        {deployData.map((elm, index) => (
          <div className={`bento_card${index === 0 ? ' tone-accent' : ''}`} key={index}>
            <span className='bento_num'>0{index + 1}</span>
            <h3 className='bento_title'>{elm.heading}</h3>
            <p className='bento_para'>{elm.para}</p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default ReadyToDeploy
